import { useState, useLayoutEffect } from 'react';

// Game 1000x520 (landscape) ya 720x800 (portrait) canvas me design hai,
// ye hook use screen ke hisaab se scale karta hai.
export default function useFitScale(stageRef) {
  const [fit, setFit] = useState({ portrait: false, W: 1000, H: 520, scale: 1 });

  useLayoutEffect(() => {
    const calc = () => {
      const st = stageRef.current;
      if (!st) return;
      const portrait = st.clientWidth / st.clientHeight < 0.95;
      const W = portrait ? 720 : 1000;
      const H = portrait ? 800 : 520;
      const scale = Math.min(st.clientWidth / W, st.clientHeight / H);
      setFit({ portrait, W, H, scale });
    };
    calc();
    window.addEventListener('resize', calc);
    return () => window.removeEventListener('resize', calc);
  }, [stageRef]);

  return fit;
}
